// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal-rule {
  width: 240px;
  height: 0;
  border: 1px solid #cccccc;
}

.arabic-arrow-div {
  text-align: left;
  margin-left: 20px;
}

.arabic-arrow {
  color: #CC0000;
  cursor: pointer;
  height: 12px;
  width: 12px;
  stroke-width: 5px;
}

.format-checkboxes {
  transform: scale(1.3);
  accent-color: #CC0000;
}

.checkbox {
  display: flex;
  flex: 1 1;
  align-items: center;
  justify-content: center;
  height: 14px;
  width: 14px;
  border-color: #CC0000;
  background-color: #CC0000;
}

.checkbox-label {
  margin-right: 8px;
  font-weight: bold;
  max-width: 155px;
  min-width: 155px;
}

.checkbox-count {
  color: #808080;

  margin-left: auto;
}

.apply-clear-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0;
}

.apply-button {
  margin: 0;
  border: 1px solid #CC0000;
  color: #ffffff;
  background-color: #CC0000;
  padding: 7px 14px;
  min-width: 126px;
  width: auto;
  font-weight: 600;
  line-height: 1.2;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.apply-button:hover {
  background-color: #a90000;
  border-color: #a90000;
}

.analytics-button {
  border: 1px solid #1a1a1a;
  display: flex;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  width: auto;
  min-width: 130px;
  justify-content: center;
  background-color: #ffffff;
  color: #1a1a1a;
  font-weight: 600;
  line-height: 1.2;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.analytics-button:hover {
  background-color: #f6f6f6;
  border-color: #000000;
}

@media (max-width: 1024px) {
  .analytics-button {
    display: none;
  }
}

.clear-button {
  margin: 0;
  border: 1px solid #1a1a1a;
  color: #1a1a1a;
  background-color: #ffffff;
  padding: 7px 14px;
  min-width: 116px;
  width: auto;
  font-weight: 600;
  line-height: 1.2;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.clear-button:hover {
  background-color: #f6f6f6;
  border-color: #000000;
}

.more-span {
  font-weight: bold;
  color: #CC0000;
  cursor: pointer;
}

@media (max-width:1024px) {
  .apply-clear-buttons {
    flex-direction: row;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/left-pane.rtl.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".horizontal-rule {\n  width: 240px;\n  height: 0;\n  border: 1px solid #cccccc;\n}\n\n.arabic-arrow-div {\n  text-align: left;\n  margin-left: 20px;\n}\n\n.arabic-arrow {\n  color: #CC0000;\n  cursor: pointer;\n  height: 12px;\n  width: 12px;\n  stroke-width: 5px;\n}\n\n.format-checkboxes {\n  transform: scale(1.3);\n  accent-color: #CC0000;\n}\n\n.checkbox {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  height: 14px;\n  width: 14px;\n  border-color: #CC0000;\n  background-color: #CC0000;\n}\n\n.checkbox-label {\n  margin-right: 8px;\n  font-weight: bold;\n  max-width: 155px;\n  min-width: 155px;\n}\n\n.checkbox-count {\n  color: #808080;\n\n  margin-left: auto;\n}\n\n.apply-clear-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 20px 0;\n}\n\n.apply-button {\n  margin: 0;\n  border: 1px solid #CC0000;\n  color: #ffffff;\n  background-color: #CC0000;\n  padding: 7px 14px;\n  min-width: 126px;\n  width: auto;\n  font-weight: 600;\n  line-height: 1.2;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.apply-button:hover {\n  background-color: #a90000;\n  border-color: #a90000;\n}\n\n.analytics-button {\n  border: 1px solid #1a1a1a;\n  display: flex;\n  padding: 8px 16px;\n  align-items: center;\n  gap: 8px;\n  width: auto;\n  min-width: 130px;\n  justify-content: center;\n  background-color: #ffffff;\n  color: #1a1a1a;\n  font-weight: 600;\n  line-height: 1.2;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.analytics-button:hover {\n  background-color: #f6f6f6;\n  border-color: #000000;\n}\n\n@media (max-width: 1024px) {\n  .analytics-button {\n    display: none;\n  }\n}\n\n.clear-button {\n  margin: 0;\n  border: 1px solid #1a1a1a;\n  color: #1a1a1a;\n  background-color: #ffffff;\n  padding: 7px 14px;\n  min-width: 116px;\n  width: auto;\n  font-weight: 600;\n  line-height: 1.2;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.clear-button:hover {\n  background-color: #f6f6f6;\n  border-color: #000000;\n}\n\n.more-span {\n  font-weight: bold;\n  color: #CC0000;\n  cursor: pointer;\n}\n\n@media (max-width:1024px) {\n  .apply-clear-buttons {\n    flex-direction: row;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
